/* Toast Notifications Utility */
(() => {
  'use strict';

  const THEME_NS = (window.theme = window.theme || {});

  const POSITIONS = ['bottom-right', 'bottom-left', 'top-right', 'top-left'];

  function ensureContainer(position = 'bottom-right') {
    let container = document.querySelector('.toast-container');
    if (!container) {
      container = document.createElement('div');
      container.className = `toast-container toast-container--${position}`;
      document.body.appendChild(container);
    } else {
      // Update position class
      POSITIONS.forEach(p => container.classList.remove(`toast-container--${p}`));
      container.classList.add(`toast-container--${position}`);
    }
    return container;
  }

  function hideToast(toast) {
    if (!toast) return;
    toast.classList.remove('show');
    // Remove after transition
    window.setTimeout(() => {
      toast.remove();
    }, 300);
  }

  function showNotification({
    message = '',
    type = 'info', // 'info' | 'success' | 'error'
    duration = 5000,
    position = 'bottom-right',
    dismissible = false
  } = {}) {
    if (!message) return null;

    const container = ensureContainer(position);

    const toast = document.createElement('div');
    toast.className = `toast-notification toast--${type}`;
    toast.setAttribute('role', type === 'error' ? 'alert' : 'status');

    const content = document.createElement('div');
    content.className = 'toast-content';
    content.innerHTML = message;

    toast.appendChild(content);

    if (dismissible) {
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'toast-close';
      btn.setAttribute('aria-label', 'Close');
      btn.innerHTML = '&times;';
      btn.addEventListener('click', () => hideToast(toast));
      toast.appendChild(btn);
    }

    container.appendChild(toast);

    // Trigger animation
    requestAnimationFrame(() => toast.classList.add('show'));

    if (duration && duration > 0) {
      window.setTimeout(() => hideToast(toast), duration);
    }

    return toast;
  }

  THEME_NS.showNotification = showNotification;
  THEME_NS.showError = (message, options = {}) => showNotification({ message, type: 'error', ...options });
  THEME_NS.showSuccess = (message, options = {}) => showNotification({ message, type: 'success', ...options });
  THEME_NS.showInfo = (message, options = {}) => showNotification({ message, type: 'info', ...options });
  THEME_NS.hideAllNotifications = () => {
    document.querySelectorAll('.toast-notification').forEach(hideToast);
  };
})();
